<div *ngIf="this.screenView[index]==2">
    <div class="basicrow m-top-i text-left ajustePaddin1">
        <div class="basicrow">
            <div class="logline full"></div>
        </div>
        <div class="basicrow text-center m-top-u" *ngIf="this.typeOfBreakdown=='LINE'">
            Por favor, indique el tipo de aver&iacute;a que presenta actualmente su L&iacute;nea Fija.
        </div>
        <div class="basicrow text-center m-top-u" *ngIf="this.typeOfBreakdown=='LINE+DSL'">
            Por favor, indique el tipo de aver&iacute;a que presenta actualmente su L&iacute;nea y DSL.
        </div>

        <div class="basicrow text-center m-top">
            <div class="caja-general">
                <div class="caja-left text-center roboto-b">
                    <div class="autorow pointerdef">
                        <input type="radio" class="pointerdef" name="radio2_{{index}}" id="ruido_{{index}}">
                        <label class="cursor" for="ruido_{{index}}">
                            <span *ngIf="this.typeOfBreakdown=='LINE'" class="spaceOption">
                                Ruido
                            </span>
                            <span *ngIf="this.typeOfBreakdown=='LINE+DSL'" class="spaceOption">
                                Sin internet y con voz
                            </span>
                        </label>
                    </div>
                </div>
                <div class="caja-right text-center roboto-b">
                    <div class="autorow pointerdef">
                        <input type="radio" class="pointerdef" name="radio2_{{index}}" id="sin_tono_{{index}}">
                        <label class="cursor" for="sin_tono_{{index}}">
                            <span *ngIf="this.typeOfBreakdown=='LINE'" class="spaceOption">
                                Sin Tono
                            </span>
                            <span *ngIf="this.typeOfBreakdown=='LINE+DSL'" class="spaceOption">
                                Sin internet y sin voz
                            </span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div class="basicrow m-top-i">
            <div class="logline full"></div>
        </div>
        <div class="basicrow f-bmed roboto-b margin-top1">
            Detalle de la Aver&iacute;a
        </div>
        <div class="basicrow">
            <div class="caja-text-left m-top">
                <input placeholder="N&uacute;mero de contacto 1" class="inp-f" [(ngModel)]="this.nroContrato1" [appOnlyNumber] maxlength="10">
            </div>
            <div class="caja-text-right m-top">
                <input placeholder="N&uacute;mero de contacto 2" class="inp-f" [(ngModel)]="this.nroContrato2" [appOnlyNumber] numbers-only maxlength="10">
            </div>
        </div>
        <div class="basicrow m-top-i">
            <textarea class="t-areadef" maxlength="999" placeholder="Ingrese aqu&iacute; una breve explicaci&oacute;n de lo que desea reportar" [(ngModel)]="this.detalle"></textarea>
        </div>
        <div class="basicrow m-top-i">
            <div class="logline full"></div>
        </div>
        <div class="basicrow m-top">
            <a (click)="this.sendReport(index,this.subscriber,this.productType)" class="btns def-i red pull-right vcenter">
                <span class="tabcell">
                    Continuar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                </span>
            </a>
            <a (click)="this.back(index)" class="btns def-i gray pull-left vcenter">
                <span class="tabcell">
                    <i class="fa fa-angle-left" aria-hidden="true"></i>&nbsp;&nbsp;Regresar
                </span>
            </a>
        </div>
    </div>
</div>